<div class="x-verdict-demo">
    <!-- Header -->
    <h2 class="gradient-text fw-bold">X-Verdict </h2>
    <p class="text-muted mb-4">
        Upload case files, spot key facts, and review eligibility fast.
    </p>

  <!-- Stats Bar -->
    <div class="row g-3 mb-3">
    <div class="col-12 col-sm-6 col-lg-3">
        <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-primary">
            <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">Case Workflows</span>
                    <i class="fa fa-list-check text-primary me-2"></i>
                </div>
                <div class="h4 fw-bold mb-0">Easy</div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-6 col-lg-3">
        <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-success">
            <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">Case Intake</span>
                    <i class="fa fa-file-signature text-success me-2"></i>
                </div>
                <div class="h4 fw-bold mb-0">Fast</div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-6 col-lg-3">
        <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-danger">
            <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">Eligibility Review</span>
                    <i class="fa fa-check-circle text-danger me-2"></i>
                </div>
                <div class="h4 fw-bold mb-0">Instant</div>
            </div>
        </div>
    </div>

    <div class="col-12 col-sm-6 col-lg-3">
        <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-warning">
            <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">Documents</span>
                    <i class="fa fa-file-alt text-warning me-2"></i>
                </div>
                <div class="h4 fw-bold mb-0">All Types</div>
            </div>
        </div>
    </div>
</div>


    <!-- Workflow Cards Grid -->
    <div class="row g-4">
        <!-- Law Firms -->
        <div class="col-12 col-lg-6">
            <div class="workflow-card-new">
                <div class="workflow-content">
                    <div class="d-flex align-items-start mb-2">
                        <i class="fa fa-balance-scale gradient-text me-2 mt-1"></i>
                        <h5 class="fw-bold mb-2">Case Intake & Risk Review</h5>
                    </div>
                    <p class="text-muted mb-3 small">
                        Upload contracts, letters of demand, court documents, or evidence bundles to centralise the matter, capture key facts and issue, and track case progress from intake to decision.
                    </p>
                    <button class="btn upload-button text-white w-100" @click="launch_workspace('case_intake')">
                        <i class="fa fa-upload me-2"></i>Upload Legal Document
                    </button>
                </div>
            </div>
        </div>

        <!-- Credit & Help Eligibility -->
        <div class="col-12 col-lg-6">
            <div class="workflow-card-new">
                <div class="workflow-content">
                <div class="d-flex align-items-start mb-2">
                    <i class="fa fa-hand-holding-heart gradient-text me-2 mt-1"></i>
                    <h5 class="fw-bold mb-2">Financial Eligibility & Support</h5>
                </div>
                <p class="text-muted mb-3 small">
                    Capture key financial details to review affordability and determine whether a person meets your criteria for legal aid, payment plans, or other support options.
                </p>
                <button class="btn upload-button text-white w-100" @click="launch_workspace('credit_help')">
                    <i class="fa fa-check-circle me-2"></i>Review Eligibility
                </button>
                </div>
            </div>
        </div>

        <!-- Service Delivery -->
        <div class="col-12 col-lg-6 d-none">
            <div class="workflow-card-new">
                <div class="workflow-content">
                    <div class="d-flex align-items-start mb-2">
                        <i class="fa fa-city gradient-text me-2 mt-1"></i>
                        <h5 class="fw-bold mb-2">Service Delivery — Municipal Fault Detection</h5>
                    </div>
                    <p class="text-muted mb-3 small">
                        Upload photos of potholes, burst pipes, or blocked sewers. Get auto-generated tickets, urgency scoring, department routing, and geolocation detection.
                    </p>
                    <button class="btn upload-button text-white w-100" @click="launch_workspace('service_delivery')">
                        <i class="fa fa-upload me-2"></i>Upload Service Photo
                    </button>
                </div>
            </div>
        </div>

        <!-- Risk-First Claims -->
        <div class="col-12 col-lg-6 d-none">
            <div class="workflow-card-new">
                <div class="workflow-content">
                    <div class="d-flex align-items-start mb-2">
                        <i class="fa fa-shield-alt gradient-text me-2 mt-1"></i>
                        <h5 class="fw-bold mb-2">Risk-First Claims — Adjudication & Fraud Scan</h5>
                    </div>
                    <p class="text-muted mb-3 small">
                        Upload claim forms, invoices, or medical reports. Get risk scores, fraud red flags, policy compliance scans, and recommended actions.
                    </p>
                    <button class="btn upload-button text-white w-100" @click="launch_workspace('risk_claims')">
                        <i class="fa fa-upload me-2"></i>Upload Claim Document
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>